// extracted by mini-css-extract-plugin
module.exports = {"root":"AgentThumbnail_root__0a7v5","tooltipContainer":"AgentThumbnail_tooltipContainer__7OLuN","lineClamp3":"AgentThumbnail_lineClamp3__NM2wy"};